import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';

import { Entities, fetchById, getUpdatedEntity, patch } from 'src/common/index';
import ErrorMessage from 'src/components/misc/error-message';
import AgeRatingEditForm from 'src/components/admin/age-rating/age-rating-edit-form';

class AgeRatingEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { id } = this.props;

        this.props.fetchById(id, Entities.AGE_RATING);
    }

    componentWillReceiveProps(nextProps) {
        const { ageRating } = nextProps;

        if (!this.state.startedFetching && ageRating.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { ageRating, t } = this.props;

        const finishFetching = this.state.startedFetching && !ageRating.isFetching;

        if (finishFetching) {
            // check for errors
            if (ageRating.error) return <ErrorMessage object={ageRating} />;
            // if everything is ok populate form
            else {
                let initialValues = {};

                // populate form for editing an existing ageRating
                if (ageRating.content)
                    initialValues = {
                        id: ageRating.content.id,
                        age: ageRating.content.age,
                        rating: ageRating.content.rating || 0,
                    };

                return (
                    <AgeRatingEditForm
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        ageRating={ageRating.content}
                        t={t}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { handleClose } = this.props;

        this.props.patch(data, Entities.AGE_RATING);

        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        ageRating: getUpdatedEntity(state, Entities.AGE_RATING),
    };
};

export default connect(mapStateToProps, { fetchById, patch }, null, { withRef: true })(AgeRatingEditModal);
